(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name ExperienciesController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('ExperienciesController', ExperienciesController);

    ExperienciesController.$inject = ["$timeout","debugService","espaiService","autorService","$location","$filter"];

    function ExperienciesController($timeout,debugService,espaiService,autorService,$location,$filter)
    {
    	var vm = this;

    	espaiService.experiencies = false;



        vm.getAutor = function(autor)
        {
            return autorService.getAutorByID();   
        };

        vm.goRuta = function(espai)
        {
            var slug = "";
            
            for (var i = 0; i < espaiService.data.length; i++) {
                if(espaiService.data[i].id == espai.espai_id){
                    espaiService.experiencies = true;
                    slug = '/'+language+'/espai/'+$filter('slugify')(espaiService.data[i].data.nom_ca);
                    $location.path(slug);
                }
            }
            
        };
    }    
    
})();